import numeral from 'numeral';

export const casesTypeColors = {
    cases: {
      hex: '#cc1034',
      multiplier: 500,
    },
    recovered: {
      hex: '#7dd71d',
      multiplier: 500,
    },
    deaths: {
      hex: '#2e2b2b',
      multiplier: 1500,
    },
  };


  export const options = {
    legend: {
        display: false
    },
    elements: {
        point: {
            radius: 0
        }
    },
    maintainAspectRatio: false,
    tooltips: {
        mode: 'index',
        intersect: false,
        callbacks: {
            label: function (tooltipItem) {
                return numeral(tooltipItem.value).format('+0,0');
            }
        }
    },
    scales: {
        xAxes: [
            {
                type: 'time',
                time: {
                    format: 'MM/DD/YY',
                    tooltipFormat: 'll'
                }
            }
        ],
        yAxes: [
            {
                gridLines: {
                    display: false
                },
                ticks: {
                    callback: function (value) {
                        return numeral(value).format('0a');
                    }
                }
            }
        ]
    }
}